import React from 'react';
import PropTypes from 'prop-types';

// TODO: Adopt reusable styles convention similar to https://github.deshaw.com/prg/icp-frontend
const STYLES = {
    SIZE_CLASS: {
        sm: 'w-6 h-6',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
        xl: 'w-16 h-16',
    },
    COLOR_CLASS: {
        blue: 'border-blue-900',
        green: 'border-green-900',
        yellow: 'border-yellow-900',
        red: 'border-red-900',
        gray: 'border-gray-900',
    },
};

/**
 * @param props
 * size - sm, md, lg, xl
 * color - blue, green, yellow, red, gray
 */
export const Spinner = (props) => {
    if (!props.showSpinner) return null;

    const sizeClass = STYLES.SIZE_CLASS[props.size] || STYLES.SIZE_CLASS.md;
    const colorClass =
        STYLES.COLOR_CLASS[props.color] || STYLES.COLOR_CLASS.gray;

    const style = `${sizeClass} border-b-2 ${colorClass} rounded-full animate-spin`;

    return (
        <div className="flex items-center justify-center">
            <div className={style}></div>
        </div>
    );
};

Spinner.propTypes = {
    showSpinner: PropTypes.bool,
    size: PropTypes.string,
    color: PropTypes.string,
};
